import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';

const BASEURL = environment.apiBase;

@Injectable({
  providedIn: 'root'
})
export class ClientsService {

  constructor(private http: HttpClient) { }

  public getUsers(page: number, per_page: number): Observable<any> {
    return this.http.get(`${BASEURL}/admin/clients`, {
      headers: {
        'Authorization': localStorage.getItem('token')
      },
      params: {
        page: page,
        per_page: per_page
      }
    })
      .pipe(
        tap((response: any) => {
          //console.log(response);
        }),
        //catchError(this.handleError<any>('login', []))
      );
  }

  public getNoOrdersUsers(page: number, per_page: number): Observable<any> {
    return this.http.get(`${BASEURL}/admin/clients/without-orders`, {
      headers: {
        'Authorization': localStorage.getItem('token')
      },
      params: {
        page: page,
        per_page: per_page
      }
    })
      .pipe(
        tap((response: any) => {
          //console.log(response);
        }),
        //catchError(this.handleError<any>('login', []))
      );
  }
  public getUsersFiltered(searchText: string, page: number, per_page: number): Observable<any> {
    return this.http.get(`${BASEURL}/admin/search/clients`, {
      headers: {
        'Authorization': localStorage.getItem('token')
      },
      params: {
        q: searchText,
        page: page,
        per_page: per_page
      }
    })
  }

  public getCurrentUser(): Observable<any> {
    return this.http.get(`${BASEURL}/current`, {
      headers: {
        'Authorization': localStorage.getItem('token')
      },
      responseType: 'json'
    });
  }

  public getUserById(userId: number): Observable<any> {
    return this.http.get(`${BASEURL}/admin/clients/${userId}`, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
      .pipe(
        tap((response: any) => {
          //console.log(response);
        }),
        //catchError(this.handleError<any>('login', []))
      );
  }

  public putUserById(userId: number, userData: FormData): Observable<any> {
    return this.http.put(`${BASEURL}/admin/clients/${userId}`, userData, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
      .pipe(
        tap((response: any) => {
          //console.log(response);
        }),
        //catchError(this.handleError<any>('login', []))
      );
  }

  public updateUser(userId: number, userData: any): Observable<any> {
    return this.http.put(`${BASEURL}/admin/clients/${userId}/update_patient`, userData, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    });
  }
  public updateAvatar(avatar: FormData): Observable<any> {
    return this.http.put(`${BASEURL}/auth/update_avatar`, avatar, {
      reportProgress: true,
      observe: 'events',
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
  }

  public toggleVIPClient(userId: number): Observable<any> {
    return this.http.patch(`${BASEURL}/admin/clients/${userId}/as_vip_client`, {}, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
  }
  public toggleCanViewTherapeuticDoses(userId: number): Observable<any> {
    return this.http.put(`${BASEURL}/utils/roles/toggle/${userId}/can-view-therapeutic-doses`, {}, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
  }
  public toggleBhavaniProgram(userId: number): Observable<any> {
    return this.http.put(`${BASEURL}/admin/clients/${userId}/toggle/bhavani_program`, {}, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
  }

  public getAnswerGroups(clientId: number, groupId: number): Observable<any> {
    return this.http.get(`${BASEURL}/v3/users/${clientId}/answer_groups/${groupId}`,
      {
        headers: {
          'Authorization': localStorage.getItem('token')
        }
      });
  }

  getDashboardAnswerGroups(page: number, pageSize, activeTab: string, activeSatisfactionLevelTab: string): Observable<any> {
    return this.http.get(`${BASEURL}/v3/answer_groups?page=${page}&per_page=${pageSize}&filter=${activeTab}&filterSatisfactionLevel=${activeSatisfactionLevelTab}`, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    });
  }

  public getUserAnswers(userId: number, questionaryNumber: number = 0): Observable<any> {
    let endpoint = '';
    switch (questionaryNumber) {
      case 0:
        endpoint = "initial";
        break;
      case 1:
        endpoint = "follow-up";
        break;
      case 2:
        endpoint = "athletes";
        break;
      default:
        break;
    }
    return this.http.get(`${BASEURL}/v3/users/${userId}/questionnaires/answer_groups/${endpoint}`,
      {
        headers: {
          'Authorization': localStorage.getItem('token')
        }
      });
  }
  // public getUsersAnswersById(userId: number): Observable<any> {
  //   return this.http.get(`${BASEURL}/users/${userId}/answers.json`, {
  //     headers: {
  //       'Authorization': localStorage.getItem('token')
  //     }
  //   })
  //     .pipe(
  //       tap((response: any) => {
  //         //console.log(response);
  //       }),
  //       //catchError(this.handleError<any>('login', []))
  //     );
  // }

  // public getUsersAnswersByIdAndPhase(userId: Number, phase: Number): Observable<any> {
  //   let phaseEndpoint = "answers.json";
  //   switch (phase) {
  //     case 0:
  //       break;
  //     case 1:
  //       phaseEndpoint = "answers_second_phase.json";
  //       break;
  //     case 2:
  //       phaseEndpoint = "answers_third_phase.json";
  //       break;
  //     case 3:
  //       phaseEndpoint = "answers_protocol.json";
  //       break;
  //   }
  //   return this.http.get(`${BASEURL}/users/${userId}/${phaseEndpoint}`, {
  //     headers: {
  //       'Authorization': localStorage.getItem('token')
  //     }
  //   })
  //     .pipe(
  //       tap((response: any) => {
  //         //console.log(response);
  //       }),
  //       //catchError(this.handleError<any>('login', []))
  //     );
  // }

  public getAdminUsers(): Observable<any> {
    return this.http.get(`${BASEURL}/admin/users`, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
      .pipe(
        tap((response: any) => {
          //console.log(response);
        }),
        //catchError(this.handleError<any>('login', []))
      );
  }

  public sendFollowUp(clientId: string, phase: string) {
    return this.http.put(`${BASEURL}/admin/clients/${clientId}/send_follow_up_email`, { follow_up: phase }, {
      headers: {
        'Authorization': localStorage.getItem('token')
      },
    }).pipe(
      tap((response: any) => { }),
    );

  }

  public postNote(sendNoteForm: FormData, uid: number): Observable<any> {
    return this.http.post(`${BASEURL}/admin/clients/${uid}/notes`, sendNoteForm, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
      .pipe(
        tap((response: any) => {

        })
      )
  }

  public deleteNoteById(clientId: number, noteId: number): Observable<any> {
    return this.http.delete(`${BASEURL}/admin/clients/${clientId}/notes/${noteId}`, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
      .pipe(
        tap((response: any) => {

        })
      )
  }

  public deleteCommentById(commentId: number): Observable<any> {
    return this.http.delete(`${BASEURL}/comments/${commentId}`, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
      .pipe(
        tap((response: any) => {

        })
      )
  }

  public getNotesByUser(uid: number): Observable<any> {
    return this.http.get(`${BASEURL}/admin/clients/${uid}/notes`, {
      headers: {
        'Authorization': localStorage.getItem('token'),
      }
    })
      .pipe(
        tap((response: any) => {

        })
      )
  }

  public redirectToPay(): Observable<any> {
    return this.http.get(`${BASEURL}/pay`, {
      headers: {
        'Authorization': localStorage.getItem('token'),
      }
    })
      .pipe(
        tap((response: any) => {

        })
      )
  }

}
